module.exports = __webpack_public_path__ + "static/media/hall-P7.2e3b6bfd.svg";